export type MessageId = number|string

export type Message = {
	id: MessageId
	title: string
}

export type SentStatus = 'any' | 'sent' | 'unsent'
export const isSentStatus = (value:string): value is SentStatus => value == "any"
	|| value == "sent"
	|| value == "unsent"

export type OpenedStatus = 'any' | 'opened' | 'unopened'
export const isOpenedStatus = (value:string): value is OpenedStatus => value == "any"
	|| value == "opened"
	|| value == "unopened"



// WEBPACK FOOTER //
// ./src/contacts/querybuilder-filters/communications-message/data.ts